var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 190.18,
    height: 186.055,
    viewBox: "0 0 190.18 186.055",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    d: "M0,0H190.18V113.908L0,186.055Z",
    fill: "#fff",
    opacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape1);
export default __webpack_public_path__ + "static/media/shape-1.725f520d426f8f346ef74a561f0f9363.svg";
export { ForwardRef as ReactComponent };